var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.97,
    height: 17.4,
    viewBox: "0 0 8.97 17.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-attach",
    "data-name": "Icon ionic-ios-attach",
    d: "M18.24,7.263a.607.607,0,0,0-.606.606v7.549a3.131,3.131,0,0,1-.854,2.14,3.073,3.073,0,0,1-2.155.92H14.1a3.018,3.018,0,0,1-2.128-.955,3.118,3.118,0,0,1-.928-2.143V5.64a2.11,2.11,0,0,1,.672-1.534A2.31,2.31,0,0,1,13.3,3.473,2.161,2.161,0,0,1,15.487,5.64v9.094a1.227,1.227,0,0,1-1.126,1.25,1.193,1.193,0,0,1-1.1-1.25V9.546a.606.606,0,0,0-1.212,0v5.188a2.33,2.33,0,0,0,3.965,1.747,2.453,2.453,0,0,0,.68-1.747V5.64a3.394,3.394,0,0,0-3.405-3.39,3.408,3.408,0,0,0-2.415.99,3.35,3.35,0,0,0-1.006,2.4v9.739a4.34,4.34,0,0,0,1.266,3.029,4.2,4.2,0,0,0,2.955,1.239h.528A4.242,4.242,0,0,0,17.568,18.4,4.362,4.362,0,0,0,18.5,17.06a4.065,4.065,0,0,0,.346-1.635V7.869A.6.6,0,0,0,18.24,7.263Z",
    transform: "translate(-9.872 -2.25)",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosAttach);
export default __webpack_public_path__ + "static/media/ios-attach.a6189b269c0683457b30ddb1a34ee917.svg";
export { ForwardRef as ReactComponent };